import React from 'react';
import { Service, ServiceStatus } from '../types';
import { STATUS_LABELS, STATUS_COLORS } from '../constants';
import Pulse from './Pulse';
import Sparkline from './Sparkline';

interface ServiceCardProps {
  service: Service;
  status: ServiceStatus;
  onReport: (service: Service) => void;
}

export default function ServiceCard({ service, status: s, onReport }: ServiceCardProps) {
  const isOffline  = s.status === 'offline';
  const isDegraded = s.status === 'degraded';
  const statusColor = STATUS_COLORS[s.status];

  return (
    <div
      className={`service-card ${isOffline ? 'offline-card' : ''}`}
      style={{
        background: '#0d0f17',
        border: '1px solid #1a1d2a',
        borderRadius: '12px',
        padding: '1rem 1.25rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '0.75rem',
      }}
    >
      {/* Left: name + url */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.85rem', minWidth: 0 }}>
        <Pulse status={s.status} />
        <div style={{ minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
            <span style={{ fontFamily: "'IBM Plex Mono', monospace", fontWeight: 600, fontSize: '0.9rem', color: '#e8eaf0' }}>
              {service.name}
            </span>
            <span style={{
              fontSize: '0.65rem', background: '#1a1d2a', color: '#555',
              padding: '0.15rem 0.45rem', borderRadius: '4px', letterSpacing: '0.08em', textTransform: 'uppercase',
            }}>
              {service.group}
            </span>
          </div>
          <div style={{ fontSize: '0.72rem', color: '#444', marginTop: '0.2rem', fontFamily: "'IBM Plex Mono', monospace" }}>
            {/* {service.url.replace('https://', '')} */}
          </div>
        </div>
      </div>

      {/* Right: sparkline + status + button */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '1.25rem', flexShrink: 0 }}>
        <Sparkline history={s.history} />

        <div style={{ textAlign: 'right', minWidth: '90px' }}>
          <div style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: '0.8rem', fontWeight: 700, color: statusColor }}>
            {STATUS_LABELS[s.status]}
          </div>
          {s.latency !== null && (
            <div style={{ fontSize: '0.7rem', color: '#555', marginTop: '0.1rem' }}>{s.latency}ms</div>
          )}
        </div>

        {(isOffline || isDegraded) ? (
          <button
            className="report-btn"
            onClick={() => onReport(service)}
            style={{
              background: 'rgba(255,68,68,0.08)', border: '1px solid rgba(255,68,68,0.2)', borderRadius: '7px',
              padding: '0.4rem 0.75rem', color: '#ff6666', fontFamily: "'IBM Plex Mono', monospace",
              fontSize: '0.72rem', cursor: 'pointer', letterSpacing: '0.04em', whiteSpace: 'nowrap',
            }}
          >
            Log Issue →
          </button>
        ) : (
          <div style={{ width: '82px' }} />
        )}
      </div>
    </div>
  );
}
